import gql from 'graphql-tag';

/**
 * Query to fetch a tag by slug along with its associated posts.
 *
 * @param slug - The tag slug identifier
 * @param cursor - Pagination options for the posts list (limit, skip)
 * @returns Tag name and paginated list of posts with images, authors, and categories
 * @usedIn Tag page layout
 */
export const TAG_WITH_POSTS = gql`
  query tag($slug: String, $cursor: PagniationOptions) {
    tag(slug: $slug, postsCursor: $cursor) {
      name
      posts {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
    }
  }
`;
